import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import resources
import enTranslation from "./constant/locales/translationEN.json";
import chTranslation from "./constant/locales/translationCH.json";
import tuTranslation from "./constant/locales/translationTU.json";
import itTranslation from "./constant/locales/translationIT.json";
import poTranslation from "./constant/locales/translationPO.json";
import jpTranslation from "./constant/locales/translationJP.json";
import hiTranslation from "./constant/locales/translationHI.json";
import arTranslation from "./constant/locales/translationAR.json";
import roTranslation from "./constant/locales/translationRO.json";

const defaultLanguage = localStorage.getItem("lng");

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
    ch: { translation: chTranslation },
    tu: { translation: tuTranslation },
    it: { translation: itTranslation },
    po: { translation: poTranslation },
    jp: { translation: jpTranslation },
    hi: { translation: hiTranslation },
    ar: { translation: arTranslation },
    ro: { translation: roTranslation },
  },
  lng: defaultLanguage, // default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // React already safe from XSS
  },
});

export default i18n;
